import {getRequest, URL_SERVER} from './../requests'


export async function getMySurveys(token){
    try {
        return await getRequest(URL_SERVER + '/mysurveys', token)
    } catch (error) {
        console.error(error);
    }
}